import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { nameValidator } from "../shared/name-validator.directive";
import { emailValidator } from "../shared/email-validator.directive";
import { EmailService } from "../services/email/email.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { noSpacesValidator } from "../shared/shared/no-leading-space-validator.directive";
import { SnackBarConfig } from "../constants/snackbar.constants";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
    selector: "app-contact",
    templateUrl: "./contact.component.html",
    styleUrls: ["./contact.component.scss"],
    standalone: false,
})
export class ContactComponent {
    public contactForm!: FormGroup;
    public locationUrl!: SafeResourceUrl;

    constructor(
        private formBuilder: FormBuilder,
        private emailService: EmailService,
        private snackBar: MatSnackBar,
        private sanitizer: DomSanitizer,
    ) {}

    ngOnInit() {
        this.contactForm = this.formBuilder.group({
            name: ["", [Validators.required, nameValidator(), noSpacesValidator()]],
            email: ["", [Validators.required, emailValidator()]],
            subject: ["", [Validators.required, noSpacesValidator()]],
            message: ["", [Validators.required, noSpacesValidator()]],
        });

        this.locationUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            "https://www.google.com/maps?q=12.9317416,77.6852039&z=17&output=embed",
        );
    }

    public isInvalid(controlName: string, validatorName?: string): boolean {
        const contorl = this.contactForm.get(controlName);
        if (validatorName) {
            return contorl!.errors?.[validatorName];
        }
        return contorl!.invalid && contorl!.touched;
    }

    private openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            ...SnackBarConfig.Defaults,
        });
    }

    private trimSpaces(): void {
        const controlNames = ["name", "subject", "message"];
        controlNames.forEach((controlName) => {
            const control = this.contactForm.get(controlName);
            if (control && control.value) {
                control.setValue(control.value.trim());
            }
        });
    }

    public onSubmit(): void {
        this.trimSpaces();
        const emailData = {
            contactBody: this.contactForm.value,
        };
        this.emailService.sendContactEmail(emailData).subscribe({
            next: (response) => {
                this.openSnackBar(response, SnackBarConfig.Actions.OKAY);
            },
            error: (error) => {},
        });
        this.contactForm.reset();
    }
}
